// extracted by mini-css-extract-plugin
export var auto = "_2k-1";
export var spinner = "_2k-0";